var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"historyText"},[_vm._v("Link: "),_c('a',{attrs:{"id":"link","href":_vm.command.data.link,"arial-label":_vm.command.data.link,"target":"_blank"}},[_vm._v(_vm._s(_vm.command.data.link))])])])}
var staticRenderFns = []

export { render, staticRenderFns }